import React, { Component } from 'react';
import PropTypes from 'prop-types';
import algoliasearch from 'algoliasearch/lite';
import {
  InstantSearch,
  Configure,
  Hits,
  Highlight,
  connectSearchBox,
  RefinementList
} from 'react-instantsearch-dom';
import {FormLocation} from '@Components/icon/icon';
import Autocomplete from './search-Autocomplete';
import './assets/styles/_index.scss';

const VirtalSearchBox = connectSearchBox(() => null);

const algoliaClient = algoliasearch(
  `${process.env.GATSBY_ALGOLIA_APP_ID}`,
  `${process.env.GATSBY_ALGOLIA_SEARCH_KEY}`
);
const searchClient = {
  ...algoliaClient,
  search(requests) {
    if (requests.every(({ params }) => !params.query)) {
      // dont send algolia request on page load
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          processingTimeMS: 0,
        })),
      });
    }
    return algoliaClient.search(requests);
  },
};

class SearchInputBox extends Component {
  state = {
    query: '',
  };

  onSuggestionSelected = (_, { suggestion }) => {
    this.setState({
      query: suggestion.area,
    });
  };

  onSuggestionCleared = () => {
    this.setState({
      query: '',
    });
  };

  render() {
    const { query } = this.state;
    const index_name = `${process.env.GATSBY_ALGOLIA_INDEX_NAME}`
    // const index_name = `prod_properties`
    
    return (
      <>
      <div className="input-wrap">
        <div className="ico-loca"><FormLocation/>
        

       
        </div>
        <InstantSearch indexName={index_name} searchClient={searchClient}>
          {/* <div className="d-none">
              <RefinementList
                attribute="publish"
                defaultRefinement={["true"]}
              />
          </div> */}
          <Configure filters={`publish:true`} hitsPerPage={5} distinct={true} />
          <Autocomplete
            onSuggestionSelected={this.onSuggestionSelected}
            onSuggestionCleared={this.onSuggestionCleared}
            handleChange={this.props.handleChange}
          />
        </InstantSearch>
        
      </div>
      <InstantSearch indexName={index_name} searchClient={searchClient}>
          <VirtalSearchBox defaultRefinement={query} />
        </InstantSearch>
      </>
    );
  }
}

function Hit(props) {
  return (
    <div>
      <Highlight attribute="area" hit={props.hit} />
    </div>
  );
}

Hit.propTypes = {
  hit: PropTypes.object.isRequired,
};

export default SearchInputBox;